const { default: axiosIns } = require('@/libs/axios')

const StatisticsService = {
  // GET - StatisticsApiController
  async getStatistics(cfg, tab, accountId) {
    return axiosIns.get(`/statistics?accountId=${accountId}`, {
      params: {
        cfg,
        tab,
      },
    }).then(response => response.data)
  },
  async exportCsv(type, cfg, accountId) {
    return axiosIns.get(`/statistics/export/csv?accountId=${accountId}&type=${type}&cfg=${cfg}`, { responseType: 'blob' }).then(response => response.data)
  },
  async exportExcel(type, cfg, accountId) {
    return axiosIns.get(`/statistics/export/excel?accountId=${accountId}&type=${type}&cfg=${cfg}`, { responseType: 'blob' }).then(response => response.data)
  },
  // POST - StatisticsApiController
  async filter(filter, type, accountId) {
    return axiosIns.post(`/statistics?accountId=${accountId}&type=${type}`, filter).then(response => response.data)
  },
  async getChart(filter, type, accountId) {
    return axiosIns.post(`/statistics/chart?accountId=${accountId}&type=${type}`, filter).then(response => response.data)
  },
  async createConfig(config, accountId) {
    return axiosIns.post(`/statistics/config?accountId=${accountId}`, config).then(response => response.data)
  },
  async createPreset(model, accountId) {
    return axiosIns.post(`/statistics/preset?accountId=${accountId}`, model).then(response => response.data)
  },
  async createPropertyFilters(propertyFilters, accountId) {
    return axiosIns.post(`/statistics/filters?accountId=${accountId}`, propertyFilters).then(response => response.data)
  },
  // PUT - StatisticsApiController
  async updateValue(editModal, accountId) {
    return axiosIns.put(`/statistics/value/${editModal.id}?accountId=${accountId}`, editModal).then(response => response.data)
  },
  async updatePreset(model, accountId) {
    return axiosIns.put(`/statistics/preset/${model.id}?accountId=${accountId}`, model).then(response => response.data)
  },
  // PATCH - StatisticsApiController
  async updateStatus(type, status, id, accountId) {
    return axiosIns.patch(`/statistics/status?accountId=${accountId}&type=${type}&status=${status}`, id).then(response => response.data)
  },
  // DELETE - StatisticsApiController
  async deletePreset(model, accountId) {
    return axiosIns.delete(`/statistics/preset/${model.id}?accountId=${accountId}`, { data: { ...model } }).then(response => response.data)
  },
}

export default StatisticsService
